(() => {
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toUpperCase();
  const headingMatches = (element, names) => {
    const text = normalize(element.textContent);
    return names.some((name) => text === name || text.startsWith(`${name} `));
  };
  const directChild = (root, node) => {
    let current = node;
    while (current && current.parentElement !== root) current = current.parentElement;
    return current && current.parentElement === root ? current : null;
  };
  const findSmallestHeading = (root, names) => {
    const selectors = 'h1,h2,h3,h4,h5,h6,p,strong,b,div';
    return Array.from(root.querySelectorAll(selectors)).find((element) => {
      if (!headingMatches(element, names)) return false;
      return !Array.from(element.children).some((child) => headingMatches(child, names));
    });
  };

  const applyApprovedCopy = (root, template) => {
    if (!template) return;
    const fragment = template.content.cloneNode(true);
    const productInfoHeading = findSmallestHeading(root, ['PRODUCT INFO', 'PRODUCT INFORMATION']);
    const productInfoBlock = productInfoHeading ? directChild(root, productInfoHeading) : null;

    if (productInfoBlock) {
      let previous = productInfoBlock.previousElementSibling;
      while (previous) {
        const remove = previous;
        previous = previous.previousElementSibling;
        remove.remove();
      }
      productInfoBlock.before(fragment);
    } else {
      root.replaceChildren(fragment);
    }
  };

  const removeLegacyServiceCopy = (root) => {
    const returnHeading = findSmallestHeading(root, [
      'RETURN & REFUND POLICY',
      'RETURN AND REFUND POLICY',
      'REFUND & RETURN POLICY',
      'REFUND AND RETURN POLICY',
      'RETURN POLICY'
    ]);
    const shippingHeading = findSmallestHeading(root, ['SHIPPING INFO', 'SHIPPING INFORMATION']);
    const firstHeading = returnHeading || shippingHeading;
    const firstBlock = firstHeading ? directChild(root, firstHeading) : null;

    if (firstBlock) {
      let current = firstBlock;
      while (current) {
        const remove = current;
        current = current.nextElementSibling;
        remove.remove();
      }
    }

    root.innerHTML = root.innerHTML
      .replace(/\(\s*change\s+this\s*\)/gi, '')
      .replace(/Your order will be delivered within 2-3 working days\. Regular delivery service is available in UAE only with a regular shipping charges\.?/gi, '');
  };

  const enhance = (scope = document) => {
    scope.querySelectorAll('[data-lilium-product-description]:not([data-lilium-cleaned])').forEach((root) => {
      root.setAttribute('data-lilium-cleaned', 'true');
      const container = root.closest('.product__info-container') || root.parentElement;
      applyApprovedCopy(root, container?.querySelector('template[data-lilium-approved-product-copy]'));
      removeLegacyServiceCopy(root);
      root.classList.add('is-lilium-ready');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(), { once: true });
  } else {
    enhance();
  }
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
